import { render } from "./SpamPage.vue?vue&type=template&id=64196277&ts=true"
import script from "./SpamPage.vue?vue&type=script&lang=ts"
export * from "./SpamPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__